module.exports = __webpack_public_path__ + "img/GrüneSchaukel.041e65a6.svg";